import React from "react";
import { useLang } from "@/context/LanguageContext";

export default function StickyCTA({ onClick }) {
  const { t } = useLang();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-[#080706]/95 backdrop-blur-xl border-t border-gold p-3">
      <button
        data-testid="sticky-mobile-cta-btn"
        onClick={onClick}
        className="btn-gold w-full text-xs"
      >
        {t("nav.cta")}
      </button>
    </div>
  );
}
